/* Message d'expédition dynamique (calculé côté client, car les pages sont mises en cache).
   - Jour ouvré (lun-ven) AVANT l'heure de cutoff → countdown : « Commandez dans les Xh Ymin <today> ».
   - Sinon (après cutoff, ou week-end) → « <else> dès <prochain jour ouvré> » (dès lundi le week-end).
   Markup : <p data-ship-msg data-cutoff-hour data-cutoff-min data-before data-today data-else>
              <span data-ship-text></span></p> */
(function () {
  'use strict';
  var DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function nextBusinessDay(now) {
    var d = new Date(now.getTime());
    do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
    return d;
  }
  function init(el) {
    if (el.__shipInit) return;
    el.__shipInit = true;
    var ch = parseInt(el.getAttribute('data-cutoff-hour') || '12', 10);
    var cm = parseInt(el.getAttribute('data-cutoff-min') || '0', 10);
    var before = el.getAttribute('data-before') || 'Commandez dans les';
    var today = el.getAttribute('data-today') || "pour une expédition aujourd'hui";
    var elseTxt = el.getAttribute('data-else') || "Commandez aujourd'hui, votre commande sera expédiée";
    var target = el.querySelector('[data-ship-text]') || el;
    function render() {
      var now = new Date();
      var isWeekday = now.getDay() >= 1 && now.getDay() <= 5;
      var cutoff = new Date(now.getTime());
      cutoff.setHours(ch, cm, 0, 0);
      if (isWeekday && now < cutoff) {
        var diff = cutoff - now;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var t = h > 0 ? (h + 'h ' + pad(m) + 'min') : (m + 'min');
        target.innerHTML = before + ' <strong>' + t + '</strong> ' + today;
        el.removeAttribute('data-ship-else');
      } else {
        var nb = nextBusinessDay(now);
        target.innerHTML = elseTxt + ' <strong>dès ' + DAYS[nb.getDay()] + '</strong>';
        el.setAttribute('data-ship-else', '');
      }
    }
    render();
    el.__shipTimer = setInterval(render, 30000);
  }
  function boot() {
    var els = document.querySelectorAll('[data-ship-msg]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
